<div class="flex-row">
  <app-avatar [src]="task.message.from.details.avatarUrl" class="avatar" (click)="showUserInteractions()"></app-avatar>

  <div>
    <div class="line">
      <span class="name" data-testid="message-nice-name">
        <ng-container *ngIf="task.message.from.name !== ''; else profileName">{{
          task.message.from.name
        }}</ng-container>
        <ng-template #profileName>{{ task.message.from.details['profile-name'] }}</ng-template>
      </span>
      <span *ngIf="task.conversation" class="bubble cpt">{{ task.conversation.tasks_and_answers_number }}</span>
      <span *ngIf="task.message.from.is_vip" class="bubble vip" translate="m/vip"></span>
    </div>

    <div class="line line2">
      <div
        *ngIf="
          (displayProfileId && task.message.from.details['profile-id']) ||
          task.message.from.details.followers_count >= 0
        ">
        <!-- channel alias (ex "@toto" for twitter) -->
        <span *ngIf="displayProfileId && task.message.from.details['profile-id']">{{
          task.message.from.details['profile-id']
        }}</span>

        <span *ngIf="task.message.from.details.followers_count >= 0"
          >{{ task.message.from.details.followers_count }} <span translate="inbox/message/followers"></span
        ></span>
      </div>

      <div *ngIf="task.message.from.inbox_custom_fields" class="custom-fields">
        <ng-container *ngFor="let customField of task.message.from.inbox_custom_fields">
          <span *ngIf="customField.value"> {{ customField.label }}:&nbsp;{{ customField.value }} </span>
        </ng-container>
      </div>

      <div *ngIf="task.message.details.rating">
        <span class="stars">
          <mat-icon class="value" *ngFor="let item of [].constructor(task.message.details.rating.value)"
            >star_rate</mat-icon
          >
          <ng-container *ngIf="task.message.details.rating.scale">
            <mat-icon
              class="scale"
              *ngFor="let item of [].constructor(task.message.details.rating.scale - task.message.details.rating.value)"
              >star_rate</mat-icon
            >
          </ng-container>
        </span>
        <span
          >{{ task.message.details.rating.value
          }}<ng-container *ngIf="task.message.details.rating.scale"
            >/{{ task.message.details.rating.scale }}</ng-container
          ></span
        >
      </div>
    </div>
  </div>
</div>
